import { useQuery } from "@tanstack/react-query"
import { NPSQuery } from "../lib/NPSQuery"

export function useNPSQuery(...args: Parameters<typeof NPSQuery>) {
  return useQuery(NPSQuery(...args))
}
